import { createFileRoute } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import { Badge } from "@/client/components/shad/badge";
import { MapConfigForm } from "@/client/forms/map";

export const Route = createFileRoute("/(protected)/settings/map/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Map</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <MapConfigForm />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>
                  Map status{" "}
                  <Badge className="bg-lime-50 text-lime-700 dark:bg-lime-950 dark:text-lime-300">
                    Active
                  </Badge>
                </CardTitle>
                <CardDescription>Using local offline maps</CardDescription>
              </CardHeader>
              <CardContent>Map content</CardContent>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
